import React, { useEffect, useCallback } from 'react'
import { PageHeader } from '../../components'
import DataTable from '../../components/DataTable/DataTable'
import { getAllMerchantGroupApi } from '../../api/merchant'
import useComponentState from '../../utils/useComponentState'
import style from './ViewMerchantGroups.module.scss'
import { connect } from 'react-redux'
import EditMerchantGroupModal from '../../components/Modals/EditMerchantGroupModal'
import { Pagination } from '../../components';

const ViewMerchantGroups = (props) => {

  const [state, setState] = useComponentState({
    tableData: [],
    loading: false,
    error: null,
    currentPage: 0,
    pageSize: 7,
    totalPages: 0,
    sortBy: 'name',
    order: 'asc',
    editModalOpen: false,
    selectedGroup: null
  });

  const tableHeading = {
    column: [
      'Group ID',
      'Group Name (Category)',
      'Description',
      'Merchants',
    ]
  };

  const getMerchantGroups = useCallback(async (page) => {
    try {
      setState(prevState => ({ ...prevState, loading: true, error: null }));
      const response = await getAllMerchantGroupApi(props.auth.token, page, state.pageSize, state.sortBy, state.order);

      if (response && response.list) {
        setState(prevState => ({
          ...prevState,
          loading: false,
          tableData: response.list,
          totalPages: response.totalPageCount
        }));
      } else {
        setState(prevState => ({
          ...prevState,
          loading: false,
          error: 'Failed to fetch merchant groups',
          tableData: [],
          totalPages: 0
        }));
      }
    } catch (error) {
      setState(prevState => ({
        ...prevState,
        loading: false,
        error: error.message || 'Failed to fetch merchant groups',
        tableData: [],
        totalPages: 0
      }));
    }
  }, [props.auth.token, state.pageSize, state.sortBy, state.order]);

  useEffect(() => {
    getMerchantGroups(state.currentPage);
  }, [state.currentPage, getMerchantGroups]);

  const handlePagination = (page) => {
    setState(prevState => ({ ...prevState, currentPage: page }));
  };

  const handleEditClick = (group) => {
    setState(prev => ({
      ...prev,
      editModalOpen: true,
      selectedGroup: group
    }));
  };

  const handleModalClose = () => {
    setState(prev => ({
      ...prev,
      editModalOpen: false,
      selectedGroup: null
    }));
  };

  const handleEditSuccess = () => {
    // Refresh the table data
    getMerchantGroups(state.currentPage);
  };

  return (
    <div className={style.container}>
      <div className='search_area'>
        <PageHeader text='Merchant Groups' />
      </div>

      <div className={`${style.tableWrapper} table-fit`}>
        <DataTable
          tableData={state.tableData}
          tableheading={tableHeading}
          handleOnClick={() => { }}
          fetchError={state.error}
          search_filter_loading={state.loading}
          tag='merchant-groups'
          handleEditMerchant={handleEditClick}
        />
        {!state.error && (
          <Pagination
            pageCount={state.totalPages}
            onChange={handlePagination}
            currentPage={state.currentPage}
          />
        )}
      </div>

      <EditMerchantGroupModal
        show={state.editModalOpen}
        onHide={handleModalClose}
        groupData={state.selectedGroup}
        token={props.auth.token}
        onSuccess={handleEditSuccess}
      />
    </div>
  );

}

const mapStateToProps = (state) => {
  return {
    auth: state.auth.auth,
  };
};

export default connect(mapStateToProps)(ViewMerchantGroups);
